import sample_01 from './dynamicWorks.jpg';

export const dynamicWorksImpressions = {
    sample_01,
};
